import { render } from "./RegistrosXPagina.vue?vue&type=template&id=240207e4"
import script from "./RegistrosXPagina.vue?vue&type=script&lang=js"
export * from "./RegistrosXPagina.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__